<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';

    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        className?: HTMLAttributes['class'];
    }

    defineProps<Props>();
</script>

<template>
    <svg
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="className"
    >
        <path
            d="M14.1898 3.87336H11.8048V3.07836C11.8048 2.44582 11.5535 1.83918 11.1063 1.39191C10.659 0.944636 10.0523 0.693359 9.4198 0.693359H7.8298C7.19726 0.693359 6.59063 0.944636 6.14335 1.39191C5.69608 1.83918 5.4448 2.44582 5.4448 3.07836V3.87336H3.0598C2.42726 3.87336 1.82063 4.12464 1.37336 4.57191C0.926081 5.01918 0.674805 5.62582 0.674805 6.25836V13.4134C0.674805 14.0459 0.926081 14.6525 1.37336 15.0998C1.82063 15.5471 2.42726 15.7984 3.0598 15.7984H14.1898C14.8223 15.7984 15.429 15.5471 15.8763 15.0998C16.3235 14.6525 16.5748 14.0459 16.5748 13.4134V6.25836C16.5748 5.62582 16.3235 5.01918 15.8763 4.57191C15.429 4.12464 14.8223 3.87336 14.1898 3.87336ZM7.0348 3.07836C7.0348 2.86751 7.11856 2.6653 7.26765 2.51621C7.41675 2.36712 7.61896 2.28336 7.8298 2.28336H9.4198C9.63065 2.28336 9.83286 2.36712 9.98195 2.51621C10.131 2.6653 10.2148 2.86751 10.2148 3.07836V3.87336H7.0348V3.07836ZM14.9848 13.4134C14.9848 13.6242 14.901 13.8264 14.752 13.9755C14.6029 14.1246 14.4007 14.2084 14.1898 14.2084H3.0598C2.84896 14.2084 2.64675 14.1246 2.49765 13.9755C2.34856 13.8264 2.2648 13.6242 2.2648 13.4134V9.04086C4.28908 9.84392 6.44705 10.2566 8.6248 10.2572C10.8025 10.2559 12.9603 9.84319 14.9848 9.04086V13.4134ZM14.9848 7.29981C12.9801 8.18049 10.8144 8.63523 8.6248 8.63523C6.43521 8.63523 4.26948 8.18049 2.2648 7.29981V6.25836C2.2648 6.04751 2.34856 5.8453 2.49765 5.69621C2.64675 5.54712 2.84896 5.46336 3.0598 5.46336H14.1898C14.4007 5.46336 14.6029 5.54712 14.752 5.69621C14.901 5.8453 14.9848 6.04751 14.9848 6.25836V7.29981Z"
            fill="currentColor"
        />
    </svg>
</template>
